import { render, staticRenderFns } from "./VersionDropdown.vue?vue&type=template&id=0a219135&"
import script from "./VersionDropdown.vue?vue&type=script&lang=ts&"
export * from "./VersionDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./VersionDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
